import React from 'react'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SearchUI from '../../../widgets/input/SearchUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import ClientTransactionUpdateModal2SF from './ClientTransactionUpdateModal2SF'
import './ClientTxnCatTransactionList.css'

// included from ClientTxnCatTransactionListSF and ClientTxnCashTransactionListSF
const ClientTxnCatTransactionListUI = ({ context, account, financialYear, yearMonth, transactionList, filteredTxnList, txnTotal,
  onCopyToClipboard, copyToClipboardText,
  hasMore, onMoreTransactions, gettingMore,
  onSelectClick, selectedTxnIdList, category,
  topCheckboxSelected, onTopCheckBoxClick,
  updateMode, onUpdateClick, onCancelClick, successMsg,
  amountFilter, onAmountFilterChange, maxAmountFilter, onMaxAmountFilterChange,
  searchFilter, onSearchFilterChange,
  onRefreshClick, manualChecked, onShowDetailsChange,
  onCategoryTest, cagtegoryTestTxnId, cagtegoryTestResponse, cagtegoryTestSubmitted, amountTotal
}) =>
  <div className='cat_txns'>
    <LRTableActionsUI location='top' className='g_sticky'
      left={
        <div className='g_flex_h g_flex_left'>
          <Link className="backLink" to={`/su/accounts/${account.accountId}/clientTxnCats`}>
            <span className="icon icon-caret-left" />
          </Link>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
          {
            context.permissions.includes('su_manage') && (amountFilter || maxAmountFilter || searchFilter) &&
            <span className='ico_btn' onClick={onTopCheckBoxClick}>
              <input type="checkbox" checked={topCheckboxSelected} />
            </span>
          }
          {
            context.permissions.includes('su_manage') && selectedTxnIdList.length > 0 &&
            <IconButtonUI icon='icon-pencil' onClick={onUpdateClick} />
          }
          <span className='g_m_left_100 g_large'><b>{`Transactions in '${category}'`}</b></span>
        </div>
      }
      right={
        <div className='g_flex_v'>
          <div className='g_flex_h g_m_top_50'>
            <span className='g_flex_h g_m_right_50'>
              <span className='g_muted g_small g_m_right_50'>
                Manual
              </span>
              <SwitchUI
                checked={manualChecked}
                onChange={onShowDetailsChange}
              />
            </span>
            <input className='g_m_right_50 w_search' value={amountFilter} onChange={onAmountFilterChange} placeholder='Minimum amount' />
            <input className='g_m_right_50 w_search' value={maxAmountFilter} onChange={onMaxAmountFilterChange} placeholder='Maximum amount' />
            <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
          </div>
          {
            amountTotal !== 0 &&
            <span className='g_info g_text_right g_m_top_25'><b>{amountTotal}</b></span>
          }
        </div>
      }
    />
    <div className='g_flex_h'>
      {/* either financialYear or yearMonth is present */}
      <span>{financialYear}{yearMonth}, across all bank accounts</span>
      {
        hasMore &&
        <span className='g_flex_h g_flex_right'>
          {filteredTxnList.length} transaction{filteredTxnList.length == 1 ? '' : 's'} displayed
          <span className='g_ultra_muted g_m_left_50'>{txnTotal}</span>
          <LinkWithSpinnerUI className='g_m_left_100' label='Get more' spinnerOnLeft={false}
            onClick={onMoreTransactions} busy={gettingMore}
          />
        </span>
      }
      {
        !hasMore &&
        <>{filteredTxnList.length} transaction{filteredTxnList.length == 1 ? '' : 's'} displayed</>
      }
    </div>

    <SuccessMessageUI successMsg={successMsg} className='g_m_top_50' />

    <LRTableBodyUI className='data_tbl g_m_top_50'>
      {
        filteredTxnList.map((txn, i) =>
          <TxnRowUI key={i} context={context} txn={txn}
            onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
            onSelectClick={onSelectClick} selectedTxnIdList={selectedTxnIdList}
            manualChecked={manualChecked} onShowDetailsChange={onShowDetailsChange}
            onCategoryTest={onCategoryTest} cagtegoryTestTxnId={cagtegoryTestTxnId}
            cagtegoryTestResponse={cagtegoryTestResponse} cagtegoryTestSubmitted={cagtegoryTestSubmitted}
          />
        )
      }
    </LRTableBodyUI>

    <ClientTransactionUpdateModal2SF context={context}
      account={account}
      category={category}
      selectedTxnIdList={selectedTxnIdList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
    />
  </div>

const TxnRowUI = ({ context, txn, onCopyToClipboard, copyToClipboardText, onSelectClick, selectedTxnIdList, manualChecked,
  onCategoryTest, cagtegoryTestTxnId, cagtegoryTestResponse, cagtegoryTestSubmitted
}) =>
  <LRTableRowUI
    context={context}
    left={
      <RowLeftUI context={context} txn={txn}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        onSelectClick={onSelectClick} selectedTxnIdList={selectedTxnIdList}
        manualChecked={manualChecked}
        cagtegoryTestTxnId={cagtegoryTestTxnId} cagtegoryTestResponse={cagtegoryTestResponse}
      />
    }
    right={<RowRightUI context={context} txn={txn} manualChecked={manualChecked}
      onCategoryTest={onCategoryTest} cagtegoryTestTxnId={cagtegoryTestTxnId} cagtegoryTestSubmitted={cagtegoryTestSubmitted}
    />}
    className='g_flex_top'
  />

const RowLeftUI = ({ context, txn, onCopyToClipboard, copyToClipboardText, onSelectClick, selectedTxnIdList, selectedAmountList, manualChecked,
  cagtegoryTestTxnId, cagtegoryTestResponse
}) =>
  <div className='g_flex_h g_flex_top'>
    {
      txn.manualAnalysis === true && manualChecked &&
      <>
        <input type="checkbox" className='checkbox'
          checked={selectedTxnIdList.includes(txn.transactionId)} onChange={() => { }}
          onClick={context.permissions.includes('su_manage') ? onSelectClick : null}
          data-txn-id={txn.transactionId}
        />
        <div className='g_flex_v g_m_left_50'>
          <span className=''>
            {txn.transactionDateF}
            <span className='g_muted g_m_left_50'>{txn.transactionId}</span>
            <span onClick={e => e.stopPropagation()}>
              <CopyToClipboard text={txn.transactionId}
                onCopy={onCopyToClipboard}>
                <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
              </CopyToClipboard>
              {
                copyToClipboardText === txn.transactionId &&
                <span className='g_m_left_50 g_muted'>copied</span>
              }
            </span>
          </span>

          <span className='g_small'>Narration: {txn.narration}</span>

          {
            txn.cheque &&
            <span className='g_small'>Cheque: {txn.cheque}</span>
          }

          <span className='g_small'>Category: {txn.paymentCategory}; Payment mode: {txn.paymentMode}</span>

          <span className='g_m_top_25 g_flex_h g_flex_left'>
            {
              txn.analyzerCategory &&
              <BadgeUI label={txn.analyzerCategoryLabel} />
            }
            {/*
        <span className='icon icon-pencil g_link_2 g_m_left_50'
          data-txnid={txn.transactionId} onClick={onSelectClick} />
        */}
            {
              txn.manualAnalysis &&
              <span className='g_m_left_50 g_text_small g_muted'>
                (manual)
              </span>
            }
            {
              txn.matchedKeywords &&
              <span className='g_m_left_50'>
                <b>Matched keywords: {txn.matchedKeywords}</b>
              </span>
            }
          </span>
        </div>
      </>
    }
    {
      !manualChecked &&
      <>
        <input type="checkbox" className='checkbox'
          checked={selectedTxnIdList.includes(txn.transactionId)} onChange={() => { }}
          onClick={context.permissions.includes('su_manage') ? onSelectClick : null}
          data-txn-id={txn.transactionId}
        />
        <div className='g_flex_v g_m_left_50'>
          <span className=''>
            {txn.transactionDateF}
            <span className='g_muted g_m_left_50'>{txn.transactionId}</span>
            <span onClick={e => e.stopPropagation()}>
              <CopyToClipboard text={txn.transactionId}
                onCopy={onCopyToClipboard}>
                <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
              </CopyToClipboard>
              {
                copyToClipboardText === txn.transactionId &&
                <span className='g_m_left_50 g_muted'>copied</span>
              }
            </span>
          </span>

          <span className='g_small'>Narration: {txn.narration}</span>

          {
            txn.cheque &&
            <span className='g_small'>Cheque: {txn.cheque}</span>
          }

          <span className='g_small'>Category: {txn.paymentCategory}; Payment mode: {txn.paymentMode}</span>

          <span className='g_m_top_25 g_flex_h g_flex_left'>
            {
              txn.analyzerCategory &&
              <BadgeUI label={txn.analyzerCategoryLabel} />
            }
            {/*
        <span className='icon icon-pencil g_link_2 g_m_left_50'
          data-txnid={txn.transactionId} onClick={onSelectClick} />
        */}
            {
              txn.manualAnalysis &&
              <span className='g_m_left_50 g_text_small g_muted'>
                (manual)
              </span>
            }
            {
              txn.matchedKeywords &&
              <span className='g_m_left_50'>
                <b>Matched keywords: {txn.matchedKeywords}</b>
              </span>
            }
          </span>

          {
            txn.transactionId === cagtegoryTestTxnId && cagtegoryTestResponse.category &&
            <TestUI test={cagtegoryTestResponse} />
          }

        </div>
      </>
    }
  </div>

const TestUI = ({ test }) =>
  <div className='g_flex_v'>
    <span>Category: {test.category}</span>
    <span>Matched keywords: {test.matchedKeywords}</span>
    <span className='g_small g_muted'>
      Internal transfer keywords: {
        test.internalTransferKeywords.map((itk, i) =>
          <span>{itk},</span>
        )
      }
    </span>
    <span className='g_small g_muted'>
      Customers: {
        test.customerList.map((itk, i) =>
          <span>{itk},</span>
        )
      }
    </span>
    <span className='g_small g_muted'>
      Suppliers: {
        test.supplierList.map((itk, i) =>
          <span>{itk},</span>
        )
      }
    </span>
  </div>

const RowRightUI = ({ context, txn, manualChecked, onCategoryTest, cagtegoryTestTxnId, cagtegoryTestSubmitted }) =>
  <div>
    {
      txn.manualAnalysis === true && manualChecked &&
      <span>
        {txn.amount < 0 ? `(${txn.amountF2})` : txn.amountF2}
      </span>
    }
    {
      !manualChecked &&
      <span>
        {txn.amount < 0 ? `(${txn.amountF2})` : txn.amountF2}
      </span>
    }
    <LinkWithSpinnerUI className='g_m_top_200 g_muted' label='Retest'
      onClick={onCategoryTest} rowId={txn.transactionId}
    />
  </div>

export default ClientTxnCatTransactionListUI
